import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

const PageContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
`;

const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Breadcrumbs = styled.nav`
  margin-bottom: 30px;
  font-size: 14px;
  color: #666;

  a {
    color: #4f46e5;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  span {
    margin: 0 8px;
    color: #999;
  }
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 40px;
`;

const AppBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #4f46e5;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #1a1a1a;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  color: #666;
  font-size: 16px;
  max-width: 600px;
  margin: 0 auto;
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    padding: 25px;
  }
`;

const Section = styled.section`
  margin-bottom: 35px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  color: #1a1a1a;
  font-size: 1.4rem;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e8eeff;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Paragraph = styled.p`
  color: #444;
  line-height: 1.8;
  margin-bottom: 15px;
  font-size: 15px;
`;

const List = styled.ul`
  color: #444;
  line-height: 1.8;
  margin-bottom: 15px;
  padding-left: 25px;

  li {
    margin-bottom: 10px;
    font-size: 15px;
  }
`;

const ContactCard = styled.div`
  background: linear-gradient(135deg, #4f46e5 0%, #3730a3 100%);
  color: white;
  padding: 30px;
  border-radius: 12px;
  text-align: center;

  h3 {
    margin-bottom: 15px;
    font-size: 1.3rem;
  }

  p {
    margin-bottom: 10px;
    font-size: 15px;
  }

  a {
    color: white;
    font-weight: 600;
  }
`;

const FAQItem = styled.div`
  margin-bottom: 20px;
  padding: 20px;
  background: #f8f9ff;
  border-radius: 10px;
  border-left: 4px solid #4f46e5;

  h4 {
    color: #1a1a1a;
    font-size: 1rem;
    margin-bottom: 8px;
  }

  p {
    color: #555;
    font-size: 14px;
    line-height: 1.7;
    margin: 0;
  }
`;

const RelatedLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 30px;
  flex-wrap: wrap;

  a {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #eef2ff;
    color: #4f46e5;
    padding: 12px 20px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s;

    &:hover {
      background: #4f46e5;
      color: white;
    }
  }
`;

export const ConectaSoportePage = () => {
  return (
    <>
      <Navbar />
      <PageContainer>
        <ContentWrapper>
          <Breadcrumbs>
            <Link to="/">Inicio</Link>
            <span>&rsaquo;</span>
            <span>Soporte - Conecta</span>
          </Breadcrumbs>

          <Header>
            <AppBadge>Conecta</AppBadge>
            <Title>Centro de Soporte</Title>
            <Subtitle>
              Estamos aqui para ayudarte. Encuentra respuestas a tus preguntas
              o contactanos directamente.
            </Subtitle>
          </Header>

          <Card>
            <Section>
              <SectionTitle>Preguntas Frecuentes</SectionTitle>

              <FAQItem>
                <h4>Como creo mi cuenta en Conecta?</h4>
                <p>
                  Descarga la app desde la App Store, selecciona "Registrarse"
                  e ingresa el codigo de tu organizacion, tu nombre, email y
                  contrasena. Luego configura tus horarios de check-in y
                  notificaciones.
                </p>
              </FAQItem>

              <FAQItem>
                <h4>Como funcionan los check-ins diarios?</h4>
                <p>
                  Conecta te enviara una notificacion en tus horarios
                  configurados (manana y tarde). Cada check-in incluye
                  ejercicios de respiracion, reflexiones y compromisos que te
                  ayudan a desarrollar tu liderazgo consciente.
                </p>
              </FAQItem>

              <FAQItem>
                <h4>Puedo cambiar mis horarios de check-in?</h4>
                <p>
                  Si. Ve a tu perfil dentro de la app y en la seccion "Mis
                  horarios" podras seleccionar los horarios que mejor se
                  adapten a tu rutina.
                </p>
              </FAQItem>

              <FAQItem>
                <h4>Que hago si olvide mi contrasena?</h4>
                <p>
                  Contacta a tu coach o escribenos a{" "}
                  <a href="mailto:soporte@monaco-it-services.cl">
                    soporte@monaco-it-services.cl
                  </a>{" "}
                  y te ayudaremos a restablecer tu acceso.
                </p>
              </FAQItem>

              <FAQItem>
                <h4>Como puedo eliminar mi cuenta?</h4>
                <p>
                  Puedes eliminar tu cuenta directamente desde la app. Ve a tu
                  Perfil y selecciona "Eliminar cuenta" al final de la pagina.
                  Esta accion es permanente y eliminara todos tus datos,
                  incluyendo check-ins, conversaciones y progreso. Tambien
                  puedes solicitar la eliminacion escribiendo a{" "}
                  <a href="mailto:soporte@monaco-it-services.cl">
                    soporte@monaco-it-services.cl
                  </a>
                  .
                </p>
              </FAQItem>

              <FAQItem>
                <h4>Mis datos estan seguros?</h4>
                <p>
                  Si. Utilizamos encriptacion HTTPS/TLS para todas las
                  comunicaciones y tus datos se almacenan de forma segura.
                  Consulta nuestra{" "}
                  <Link to="/conecta/privacidad">Politica de Privacidad</Link>{" "}
                  para mas detalles.
                </p>
              </FAQItem>
            </Section>

            <Section>
              <SectionTitle>Contacto de Soporte</SectionTitle>
              <Paragraph>
                Si no encontraste la respuesta que buscabas, nuestro equipo
                esta disponible para ayudarte:
              </Paragraph>
              <ContactCard>
                <h3>Monaco IT Services</h3>
                <p>
                  Email:{" "}
                  <a href="mailto:soporte@monaco-it-services.cl">
                    soporte@monaco-it-services.cl
                  </a>
                </p>
                <p>
                  Sitio web:{" "}
                  <a
                    href="https://monaco-it-services.cl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    monaco-it-services.cl
                  </a>
                </p>
                <p>Horario: Lunes a Viernes, 9:00 - 18:00 (Chile)</p>
              </ContactCard>
            </Section>

            <Section>
              <SectionTitle>Informacion de la App</SectionTitle>
              <List>
                <li>
                  <strong>Nombre:</strong> Conecta
                </li>
                <li>
                  <strong>Desarrollador:</strong> Monaco IT Services
                </li>
                <li>
                  <strong>Plataforma:</strong> iOS y Android
                </li>
                <li>
                  <strong>Version actual:</strong> 1.1
                </li>
              </List>
            </Section>

            <RelatedLinks>
              <Link to="/conecta/privacidad">Politica de Privacidad</Link>
              <Link to="/conecta/eliminar-cuenta">Eliminar mi Cuenta</Link>
              <Link to="/">Volver al Inicio</Link>
            </RelatedLinks>
          </Card>
        </ContentWrapper>
      </PageContainer>
      <Footer />
    </>
  );
};
